<template>
  <div class="main survey">
    <!-- <div class="hidden-detail" @click="close">
      <i class="el-icon-close"></i>
    </div>-->
    <el-button
      @click="close"
      type="text"
      class="newBackBtn"
      icon="el-icon-arrow-left"
    >
      返回
    </el-button>
    <div class="clearfix"></div>
    <div
      v-if="data.formData.projectName !== '可配置场景'"
      class="survey-header"
    >
      <div class="title">{{ data.formData.projectName }}</div>
    </div>
    <hr />
    <div class="survey-info" v-if="data.formData.projectName !== '可配置场景'">
      <div class="title with-blue">问卷信息</div>
      <div class="survey-info-detail">
        <div
          v-if="$route.meta.projectStructureType != 2"
          class="text"
          style="width: 33.5%;"
        >
          问卷发起人:
          <span>{{ data.formData.fullName }}</span>
        </div>
        <template v-else>
          <div class="text" style="width: 33.5%;">
            经营者:
            <span>{{ data.formData.fullName }}</span>
          </div>
          <div class="text" style="width: 33.5%;">
            个体:
            <span>{{ data.formData.zooidEnterpriseName }}</span>
          </div>
        </template>
        <div class="text">
          发起人手机号码:
          <span>{{ data.formData.phone }}</span>
        </div>
        <div class="text-group">
          <div class="text">
            开始时间:
            <span>{{ data.formData.answer_start_dt }}</span>
          </div>
          <div class="text">
            提交时间:
            <span>
              {{ data.formData.answer_end_dt || data.formData.answerEndDt }}
            </span>
          </div>
          <div class="text">
            答题时间:
            <span>{{ data.formData.answerdt }}秒</span>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div class="list">
      <p class="title">问卷详情</p>
      <ul>
        <li v-for="(item, index) in list" :key="index">
          <p style="margin-bottom: 14px;">
            {{ index + 1 }}：{{ item.title }}
            <span v-if="item.type">[{{ item | questionTypeLabelFil }}]</span>
            <span v-if="![17, 18].includes(item.type)">
              （{{ item.isMustFill === 1 ? '必填' : '非必填' }}）
            </span>
          </p>
          <div
            class="item-p"
            v-if="deal(item.answer) && ![17, 18].includes(item.type)"
          >
            无
          </div>
          <div
            class="item-p"
            v-if="item.remark"
            style="color: grey; font-size: 14px;"
          >
            备注：{{ item.remark }}
          </div>
          <div
            v-if="typeof item.answer == 'object' && item.type < 8"
            class="item-p"
          >
            <div
              v-for="(item2, index2) in item.answer"
              :key="index2 + 100"
              v-if="item.answer.length > 0"
            >
              <p v-if="item.type == 5" style="margin-bottom: 10px;">
                {{ item.manyTitleJson[index2] }}：
              </p>
              <p style="margin-bottom: 10px;">{{ item2 ? item2 : '无' }}</p>
            </div>
            <div v-else>无</div>
          </div>
          <div class="enclosure" v-else-if="item.type == 8">
            <template
              v-for="(item2, index2) in item.answer"
              v-if="item.answer.length > 0"
            >
              <img
                v-if="!item2.isPdf"
                v-amplifyImg="item2.url"
                :key="index2 + 100"
                :src="item2.url"
                alt=""
              />
              <div v-else @click="open(item2.url)" :key="index2 + 100">
                <img src="//cdn.yxvzb.com/WEB/images/pdf.jpeg" />
                <span>{{ item2.name }}</span>
              </div>
            </template>
            <div v-else>无</div>
          </div>
          <div
            v-else-if="fileTypeList.includes(item.type)"
            style="display: flex; flex-wrap: wrap;"
          >
            <div
              class="item-p"
              v-for="(item2, index2) in item.answer"
              :key="index2"
              v-if="item.answer.length > 0"
            >
              <img
                v-amplifyImg="item2.url"
                v-if="item.type == 13"
                :src="item2.url"
                alt=""
                style="margin: 5px;"
              />
              <div v-else @click="open(item2.url)" :key="index2 + 100">
                <span style="color: #1989fa;">{{ item2.name }}</span>
              </div>
            </div>
            <div v-else>无</div>
          </div>
          <div v-else-if="timeTypeList.includes(item.type)">
            <p class="item-p">{{ item.answer }}</p>
          </div>
          <div v-else-if="item.type == 16" class="item-p">
            <img
              v-if="item.answer.addressPicUrl"
              v-amplifyImg="item.answer.addressPicUrl"
              :src="item.answer.addressPicUrl"
              alt=""
              style="margin: 5px;"
            />
          </div>
          <div v-else-if="item.type == 20" class="item-p">
            <img
              v-if="item.answer"
              v-amplifyImg="item.answer"
              :src="item.answer"
              alt=""
              style="margin: 5px;"
            />
          </div>
          <pre class="item-p item-pre" v-else style="line-height:1.3;">{{
            item.answer === 'null' ? '无' : item.answer
          }}</pre>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { questionType } from '@/assets/staticData';

export default {
  name: 'surveyDetail',
  props: {
    data: {
      type: Object,
      default: {
        formData: {},
        list: []
      }
    }
  },
  watch: {
    data: {
      immediate: true,
      handler(v) {
        let list = v.list;
        if (list.length) {
          this.list = list.map(item => {
            if (
              item.type == 2 ||
              item.type == 5 ||
              (item.type >= 8 && item.type != 19)
            ) {
              try {
                item.answer = JSON.parse(item.answer);
              } catch (error) {}
              if (item.type == 5) {
                item.manyTitleJson = JSON.parse(item.manyTitleJson);
              }
            }
            return item;
          });
        }
      }
    }
  },
  data() {
    return {
      fileTypeList: [8, 9, 10, 11, 12, 13],
      timeTypeList: [14, 15],
      list: []
    };
  },
  filters: {
    questionTypeFil(v) {
      return (questionType[v] || { label: '' }).label;
    }
  },
  methods: {
    close() {
      this.$router.back();
    },
    open(url) {
      window.open(url);
    },
    deal(v) {
      return v === null || v === '' || v.length === 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.item-pre {
  white-space: pre-wrap;
  word-wrap: break-word;
}
.hidden-detail {
  float: right;
  width: 1em;
  font-size: 25px;
  /*color: orange;*/
}

.front {
  width: 1em;

  &.red {
    color: #ff6944;
  }
}

.survey {
  text-align: left;
  font-size: 14px;
  .title {
    text-align: left;
    font-size: 20px;
    margin: 0.5em;

    &.with-blue {
      border-left: #00abe4 10px solid;
      text-indent: 1em;
    }
  }

  .survey-header {
    height: 3em;
  }

  .survey-info-detail {
    display: flex;
    flex-wrap: wrap;
    text-align: left;
    margin: 20px;
    box-sizing: border-box;

    .text-group {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      & > .text {
        padding: 0 2em;
        width: 49%;
      }
    }

    & > .text {
      padding: 0 2em;
      width: 49%;

      & > span {
        padding-left: 2em;
      }
    }
  }

  .survey-list {
    font-size: 16px;
    min-height: 80vh;
  }

  .list-detail-title {
    font-size: 18px;
    padding: 10px 0 0 3rem;
    text-align: left;
  }
}
.enclosure {
  display: flex;
  img {
    width: 150px;
    height: 150px;
    margin-right: 35px;
  }
  div {
    position: relative;
    span {
      position: absolute;
      width: 95%;
      bottom: 0;
      left: 0;
      color: #fff;
    }
  }
}

.list {
  text-align: left;
  p {
    font-size: 16px;
  }
  ul {
    li {
      width: 100%;
      border-bottom: 2px solid #f5f5f5;
      margin-bottom: 30px;
      .item-p {
        padding-bottom: 15px;
        padding-left: 20px;
        font-size: 16px;
      }
    }
  }
}
.enclosure {
  display: flex;
  img {
    width: 150px;
    height: 150px;
    margin-right: 35px;
  }
  div {
    position: relative;
    span {
      position: absolute;
      width: 95%;
      bottom: 0;
      left: 0;
      color: #fff;
    }
  }
}
</style>
